"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clickableTheme = void 0;
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
const clickableTheme = (0, _sdsThemeInternal.themed)({
  borderRadius: {
    "lodestar-light": "1px",
    "ursa-light": "2px"
  }
});
exports.clickableTheme = clickableTheme;
//# sourceMappingURL=clickableTheme.js.map